import { configureStore } from "@reduxjs/toolkit"
import registroTareasSlice from "../features/registroTareasSlice"
import registroAdelantosSlice from "../features/registroAdelantosSlice"
import registroProgramasSlice from "../features/registroProgramasSlice"

export const store = configureStore({
    reducer: {
        tareas: registroTareasSlice,
        adelantos: registroAdelantosSlice,
        programas:registroProgramasSlice
    }
   
})
